// extracted by mini-css-extract-plugin
export default {"container":"Anim_container__xMX3f","box":"Anim_box__37ZYY","video":"Anim_video__mCX1W"};